import React from "react";
import Seo from "../components/Seo";

export default function Returns() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-20">
      <Seo title="Returns & Refunds" description="Our return and refund policy for Rooted in Amador seed orders." path="/returns" />
      <div className="text-xs tracking-wider-2 uppercase text-sage mb-3">Orders</div>
      <h1 className="font-display text-5xl text-darkRoast mb-12">Returns & Refunds</h1>
      <div className="text-earth space-y-8 leading-relaxed">

        <section>
          <h2 className="font-display text-2xl text-darkRoast mb-3">Our promise</h2>
          <p>We stand behind every packet we sell. If something arrives damaged, is missing from your order, or you're unhappy for any reason, just reach out and we'll make it right.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-darkRoast mb-3">Damaged or incorrect orders</h2>
          <p>If your order arrives damaged or you received the wrong variety, email us at <a href="mailto:hello@rootedinamador.com" className="text-darkRoast underline hover:text-sage">hello@rootedinamador.com</a> within 14 days of delivery. We'll send a replacement or issue a full refund. Your choice.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-darkRoast mb-3">General returns</h2>
          <p>Because seeds are a perishable agricultural product, we're unable to accept returns of opened packets. Unopened packets may be returned within 14 days of delivery for a full refund, minus shipping. Please email us before sending anything back.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-darkRoast mb-3">Refunds</h2>
          <p>Approved refunds are issued to your original payment method within 5–10 business days via Stripe. You'll receive an email confirmation when the refund is processed.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-darkRoast mb-3">Contact us</h2>
          <p>We're a small local business and we genuinely want you to be happy with your seeds. Don't hesitate to reach out at <a href="mailto:hello@rootedinamador.com" className="text-darkRoast underline hover:text-sage">hello@rootedinamador.com</a>.</p>
          <p className="text-sm text-earth/70 mt-4">Last updated: June 2026</p>
        </section>

      </div>
    </div>
  );
}
